import {
  backendDelete,
  backendFetch,
  backendPatch,
  backendPost,
} from './BackendApi.ts';
import { ProviderData } from '@/common/types';
import { storageUrl } from '@/common/utilities';

export async function loadProviders(
  params?: URLSearchParams
): Promise<ProviderData[]> {
  const query = params?.toString() ? `?${params.toString()}` : '';
  const providers = await backendFetch<ProviderData[]>(`/providers${query}`, {
    credentials: 'include',
  });

  return providers.map(transformStorageUrls);
}

export async function loadProvider(id: string): Promise<ProviderData> {
  const provider = await backendFetch<ProviderData>(`/providers/${id}`, {
    credentials: 'include',
  });

  return transformStorageUrls(provider);
}

export async function updateProvider(
  id: number,
  data: FormData
): Promise<ProviderData> {
  return backendPatch<ProviderData>(`/providers/${id}`, data, {
    credentials: 'include',
  });
}

export async function createProvider(data: FormData): Promise<ProviderData> {
  return backendPost<ProviderData>('/providers', data, {
    credentials: 'include',
  });
}

export async function destroyProvider(id: number): Promise<void> {
  await backendDelete<FormData>(`/providers/${id}`, {
    credentials: 'include',
  });
}

function transformStorageUrls(provider: ProviderData): ProviderData {
  return {
    ...provider,
    avatarUrl: storageUrl(provider.avatarUrl),
    photoUrl: storageUrl(provider.photoUrl),
  };
}
